import {
  ITransactionDetailsOrder,
  ITransactionDetailsGeneral,
  ITransactionDetailsCancelable,
  ITransactionDetailsCustomer,
  ITransactionDetailsTelco,
  ITransactionDetailsAddressesTelco,
  ITransactionDetailsDelivery,
  ITransactionApplicableBenefits
} from "./types";


export default class TransactionDetailsTelco implements ITransactionDetailsTelco {

  general: ITransactionDetailsGeneral;
  order: ITransactionDetailsOrder;
  customer: ITransactionDetailsCustomer;
  addresses: ITransactionDetailsAddressesTelco;
  deliveryDetails: ITransactionDetailsDelivery;
  transaction: ITransactionDetailsCancelable;
  applicableBenefits: ITransactionApplicableBenefits;


  constructor(
    general: ITransactionDetailsGeneral,
    order: ITransactionDetailsOrder,
    customer: ITransactionDetailsCustomer,
    addresses: ITransactionDetailsAddressesTelco,
    deliveryDetails: ITransactionDetailsDelivery,
    transaction: ITransactionDetailsCancelable,
    applicableBenefits: ITransactionApplicableBenefits,
  ) {
    this.general = general;
    this.order = order;
    this.customer = customer;
    this.addresses = addresses;
    this.deliveryDetails = deliveryDetails;
    this.transaction = transaction;
    this.applicableBenefits = applicableBenefits;
  }

}
